import React from 'react';
import PropTypes from 'prop-types';
import b from 'b_';
import cn from 'classnames';
import './ConsoleFragments.css';

export function ConsolePageTitle({ className, ...props }) {
    return <div className={cn(b('ConsolePageTitle'), className)} {...props} />;
}

export default function ConsolePage({ className, title, children, ...props }) {
    return <div
        className={cn('ConsolePage', className)}
        {...props}
    >
        {title ? <ConsolePageTitle>{title}</ConsolePageTitle> : null}
        {children}
    </div>;
}

ConsolePage.propTypes = {
    title: PropTypes.node,
};
